import { render } from "./UpdateModule.vue?vue&type=template&id=019ba226&scoped=true"
import script from "./UpdateModule.vue?vue&type=script&lang=js"
export * from "./UpdateModule.vue?vue&type=script&lang=js"

import "./UpdateModule.vue?vue&type=style&index=0&id=019ba226&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019ba226"]])

export default __exports__